import { render, staticRenderFns } from "./ResourceDetailsDialog.html?vue&type=template&id=f1a529fc&"
import script from "./ResourceDetailsDialog.js?vue&type=script&lang=js&"
export * from "./ResourceDetailsDialog.js?vue&type=script&lang=js&"
import style0 from "./ResourceDetailsDialog.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports